import React from "react";
import { S3Image } from "aws-amplify-react";
import styled from "styled-components";

import { Notification, Popover, Button, Dialog, Form, Input, Radio } from "element-react";
import { convertCentsToDollar, convertDollarsToCents,round2 } from '../utils'
import { API, graphqlOperation } from 'aws-amplify'
import { updateMyProduct, deleteMyProduct, updateOrder} from '../graphql/mutations'
import {getOrder} from '../graphql/queries'
import { UserContext } from '../App'
import { CartContext } from './contexts/CartContext'





class OrderProduct extends React.Component {
  state = {
    description: "",
    price: "",
    quantity:"",
    shipped: false,
    updateProductDialog: false,
    deleteProductDialog: false
 
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  handleOrdePriceUpdate = async (orderId, order) => {

    try {

      const order_result = await API.graphql(graphqlOperation(getOrder, { id: orderId }))
      console.log({ order_result })

      const updated_product = order_result.data.getOrder.products.items;

      console.log({ updated_product })
      let total = updated_product.reduce((total, product) => total + product.price * product.quantity, 0).toFixed(2);
      let tax =round2(0.095 * total);
      var tprice = (parseFloat(total) + parseFloat(tax)).toFixed(0);

      console.log({total })
      const input = {
        id: orderId,
        price: parseFloat(tprice),
        shipped: false,
        status: "Processing",

      }
      
      const order_updated  = await API.graphql(
        graphqlOperation(updateOrder, { input }, {authMode: "AMAZON_COGNITO_USER_POOLS"})
      )

    } catch (err) {
      console.error(`Failed to update Order with id: ${orderId}`, err);

    }
  }

  handleUpdateProduct = async (productId,order) => {
    try {
      console.log({ order })
      this.setState({ updateProductDialog: false })
      const { description, price, shipped, quantity } = this.state
      const input = {
        id: productId,
        description,
        shipped,
        quantity,
        price: convertDollarsToCents(price),

      }

      const result = await API.graphql(graphqlOperation(updateMyProduct, { input }))
      console.log({ result })

      this.handleOrdePriceUpdate(order.id, order)
      Notification({
        title: "success",
        message: "Product Successfully updated in  Order!",
        type: "success"
      });

      setTimeout(() => window.location.reload(), 2000);

    } catch (err) {
      console.error(`Failed to update product with id: ${productId}`, err);

    }

  }

  handleOutOfStockProduct = async (productId,order) => {
    try {
      console.log({ order })
      this.setState({ updateProductDialog: false })
      const { description, price, shipped, quantity } = this.state
      const input = {
        id: productId,
        quantity:0,
        instock:false,
        
      }

      const result = await API.graphql(graphqlOperation(updateMyProduct, { input } ))
      console.log({ result })

      this.handleOrdePriceUpdate(order.id, order)
      Notification({
        title: "success",
        message: "Product Successfully updated in  Order!",
        type: "success"
      });

      setTimeout(() => window.location.reload(), 2000);

    } catch (err) {
      console.error(`Failed to update product with id: ${productId}`, err);

    }

  }


  handleDeleteProduct = async (productId, order)  => {
    try {
      console.log({ order })
      this.setState({ deleteProductDialog: false })
      const input = {
        id: productId

      }
      const result = await API.graphql(graphqlOperation(deleteMyProduct, { input }))
      console.log({ result })

      this.handleOrdePriceUpdate(order.id, order)
      Notification({
        title: "success",
        message: "Product Successfully Removed from Order!!",
        type: "success"
      });

      setTimeout(() => window.location.reload(), 2000);
    } catch (err) {
      console.error(` Failed to delete product with id ${productId}`, err);

    }
  }
  render() {


    const { updateProductDialog, deleteProductDialog, description, price, shipped,quantity} = this.state
    const { product, order, isEdit } = this.props;

    const {isUpdate} = 0;
 
    return (
      <UserContext.Consumer>

        {({ user }) => {
          
          return (
            <CardBox>
              <ImgWrap>
                <S3Image
                  imgKey={product.file.key}
                  theme={{
                    photoImg: {
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }
                  }}
                />
              </ImgWrap>

              <Name title={product.description}>{product.description}</Name>

              {product.instock == false && <OutPill>out of stock</OutPill>}

              <QtyPrice>
                <span>
                  {product.quantity} × ${convertCentsToDollar(product.price)}
                </span>
                <LineTotal>
                  ${convertCentsToDollar(product.price * product.quantity)}
                </LineTotal>
              </QtyPrice>

              <CartContext.Consumer>
                {({ addProduct }) => (
                  <BuyAgainRow>
                    <BuyAgainBtn
                      type="button"
                      onClick={() => {
                        addProduct({
                          id: product.id,
                          description: product.description,
                          price: product.price,
                          file: product.file,
                          shipped: product.shipped,
                          stockQuantity: product.stockQuantity !== undefined ? product.stockQuantity : 50,
                          quantity: product.quantity || 1
                        });
                        Notification({
                          title: 'Item Added to Cart!',
                          message: `Added ${product.description} to your cart.`,
                          type: 'success'
                        });
                      }}
                    >
                      🔄 Buy Again
                    </BuyAgainBtn>
                  </BuyAgainRow>
                )}
              </CartContext.Consumer>

              { /* Update / Delete Product */}
              { isEdit  && product.instock == true && (
              <AdminRow>
                { (
                  <>
                   {/* <Button
                      type="warning"
                      icon="edit"
                      className="m1"
                      onClick={() => this.setState({
                        updateProductDialog: true,
                        description: product.description,
                        shipped: product.shipped,
                        price: convertCentsToDollar(product.price),
                        quantity:product.quantity,
                      })}
                    />
                    */}
                    <Popover
                      placement="top"
                      width="160"
                      trigger="click"
                      visible={deleteProductDialog}
                      content={
                        <>
                          <p> Do you want to remove  this product and mark it as Out of Stock  ?</p>
                          <div className="text-right">
                            <Button
                              size="mini"
                              type="text"
                              className="m-1"
                              onClick={() => this.setState({ deleteProductDialog: false })}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="primary"
                              size="mini"
                              className="m-1"
                              onClick={() => this.handleOutOfStockProduct(product.id,order)}
                            >
                              confirm
                            </Button>
                          </div>
                        </>
                      }
                    >
                      
                      <Button
                        type="danger"
                        icon="delete"
                        onClick={() => this.setState({ deleteProductDialog: true })} />
                    </Popover>

                    
                    
                  </>
                )}

              </AdminRow>
              )}

              { /* Update Product Dialog */}
             
              <Dialog
                title="Update Product"
                size="large"
                customClass="dialog"
                visible={updateProductDialog}
                onCancel={() => this.setState({ updateProductDialog: false })}

              >
                <Dialog.Body>
                  <Form>
                    <Form.Item label="Update Description">
                      <Input
                        placeholder="Product escription"
                        value={description}
                        trim={true}
                        onChange={description => this.setState({ description })}
                      />
                    </Form.Item>
                    <Form.Item label="Update Product Price">
                      <Input
                        type="number"
                        icon="minus"
                        placeholder="Price($USD)"
                        value={price}
                        onChange={price => this.setState({ price })}
                      />
                    </Form.Item>
                    <Form.Item label="Update Product quantity">
                      <Input
                        type="number"
                        icon="minus"
                        placeholder="Price($USD)"
                        value={quantity}
                        onChange={quantity => this.setState({ quantity})}
                      />
                    </Form.Item>
                    <Form.Item label="Update shipping">
                      <div className="text-center"> 
                        <Radio
                          value="true"
                          checked={shipped === true}
                          onChange={() => this.setState({ shipped: true })}
                        >
                          Shipped
                        </Radio>
                        <Radio
                          value="false"
                          checked={shipped === false}
                          onChange={() => this.setState({ shipped: false })}
                        >
                          Emailed
                        </Radio>

                      </div>
                    </Form.Item>

                  </Form>
                </Dialog.Body>
                <Dialog.Footer>
                  <Button
                    onClick={() => this.setState({ updateProductDialog: false })}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="primary"
                    onClick={() => this.handleUpdateProduct(product.id, order )}
                  >
                    Update
                  </Button>

                </Dialog.Footer>


              </Dialog>




            </CardBox>
          )

        }}

      </UserContext.Consumer>

    )

  }
}

export default OrderProduct;

/* ---------- styles ---------- */
const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  background: #fff;
  border: 1px solid rgba(31, 45, 61, 0.08);
  border-radius: 14px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(31, 45, 61, 0.04);
`;

const ImgWrap = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  display: grid;
  place-items: center;
  overflow: hidden;
  border-radius: 10px;
  background: #f7f9fa;
`;

const Name = styled.p`
  margin: 10px 2px 6px;
  color: #1f2d3d;
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.35;
  word-break: break-word;

  /* clamp to two lines, reserve the space so rows stay aligned */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(2 * 1.35em);
`;

const OutPill = styled.span`
  align-self: flex-start;
  background: rgba(239, 83, 80, 0.12);
  color: #d32f2f;
  font-size: 0.74rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
  margin: 0 2px 6px;
`;

const QtyPrice = styled.div`
  margin-top: auto; /* pin to the card bottom so rows align */
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0 2px;
  color: #6a7b8a;
  font-size: 0.85rem;
`;

const LineTotal = styled.span`
  color: #0a8f57;
  font-size: 1rem;
  font-weight: 800;
`;

const AdminRow = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
`;

const BuyAgainRow = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
`;

const BuyAgainBtn = styled.button`
  background: rgba(1, 191, 113, 0.08);
  color: #0a8f57;
  border: 1px solid rgba(1, 191, 113, 0.25);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #01bf71;
    color: #fff;
    border-color: #01bf71;
  }
`;
